/* eslint-disable no-console */

function envDebugFlag() {
  if (process.env.REACT_APP_DEBUG_LOGS === 'true') return true;
  if (typeof window !== 'undefined') {
    if (window.__SKINNY_DEBUG) return true;
    try {
      if (window.localStorage && window.localStorage.getItem('skinny_debug') === 'true') {
        return true;
      }
    } catch (_) {
      // ignore storage access errors
    }
  }
  return false;
}

export function isVerboseLoggingEnabled() {
  return envDebugFlag();
}

export function debugLog(...args) {
  if (!isVerboseLoggingEnabled()) return;
  try {
    console.log(...args);
  } catch (_) {
    // noop
  }
}


